import { useAuth, useCurrentUser } from '@lastbrand/fe-common/universal-auth'
import { useState, useEffect } from 'react'

function useLoginDetails(): {
  isLoggedIn: boolean
  customerEmail: string | undefined
} {
  const [customerEmail, setCustomerEmail] = useState<string | undefined>('')
  const { isLoggedIn } = useAuth()
  const user = useCurrentUser()

  useEffect(() => {
    const customerEmailFromLS = isLoggedIn ? user?.attributes?.email : ''
    setCustomerEmail(customerEmailFromLS)
  }, [isLoggedIn, user])

  return {
    isLoggedIn,
    customerEmail,
  }
}

export default useLoginDetails
